import Layout from "@/components/Layout/Layout";
import { Landing } from "@/features/misc";
import Head from "next/head";
import type { ReactElement } from "react";

function Careme() {
	return (
		<>
			<Head>
				<title>ケアミー | 生理・PMSの共有アプリ</title>
				<meta
					name="description"
					content="ケアミーは、生理・PMSの共有アプリです。生理やPMSをパートナーにLINEで共有できます。"
				/>
				<meta
					name="viewport"
					content="width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no"
				/>
			</Head>
			<Landing />
		</>
	);
}

Careme.getLayout = function getLayout(page: ReactElement) {
	return <Layout hideHeader>{page}</Layout>;
};

export default Careme;
